// extracted by mini-css-extract-plugin
export default {"input-error":"InputError_input-error__wRqLr","input-error__text":"InputError_input-error__text__rOL81","warning-icon":"InputError_warning-icon__q0C44"};